{
  "button": {
    "back": "Назад",
    "cancel": "Скасувати",
    "confirm": "Підтвердити",
    "fullscreen_enter": "Ввійти в повноекранний режим",
    "fullscreen_exit": "Вийти з повноекранного режиму",
    "refresh": "Оновити",
    "toggle_dark": "Змінити тему",
    "toggle_langs": "Змінити мову",
    "remove": "Видалити",
    "clear_all": "Очистити все",
    "delete": "Видалити",
    "edit": "Редагувати",
    "buy_now": "Купити зараз",
    "enter_another_card": "Введіть іншу картку",
    "try_again": "Спробуйте знову",
    "enter_another_code": "Введіть інший код",
    "submit_code": "Надіслати код",
    "download": "Завантажити",
    "no": "Ні",
    "go_to_homepage": "Перейти на домашню сторінку",
    "slide_back": "Попередній слайд",
    "slide_forward": "Наступний слайд",
    "exit": "Вихід",
    "full": "Повний",
    "regular": "Регулярний",
    "rename": "Перейменувати"
  },
  "common": {
    "loading": "Завантаження...",
    "loading_failed": "Не вдалося завантажити",
    "empty_search": "Не знайдено результатів із назвою \"{searchValue}\".",
    "empty_list": "Список порожній.\nПриходьте пізніше.",
    "data_not_found": "Дані не знайдено або сервер не відповідає. Спробуйте пізніше.",
    "empty_events_list": "Подій ще немає"
  },
  "not-found": "Не знайдено",
  "locales": {
    "en": "English",
    "de": "German",
    "es": "Spanish",
    "uk-UA": "Ukrainian",
    "pt": "Portugal",
    "pl": "Polish",
    "fr": "French",
    "he": "Hebrew",
    "it": "Italian",
    "title": "Виберіть мову сайту",
    "ko": "Korean",
    "ca": "Catalan",
    "zh": "Chinese",
    "bs": "Lokalni"
  },
  "baseHeader": {
    "menu": {
      "account": "Ваш аккаунт",
      "language": "Мова: {currentLanguage}",
      "logout": "Вийти",
      "manage_following": "Керувати підписками",
      "select_language": "Оберіть мову",
      "selected_videos": "Вибрані відео",
      "my_clips_and_highlights": "Мої кліпи/головні моменти"
    }
  },
  "labels": {
    "sign_in": "Увійти",
    "sign_up": "Зареєструватися",
    "continue": "Продовжити",
    "email": "Електронна пошта",
    "forgot_password": "Забули пароль",
    "password": "Пароль",
    "highlights": "Основний Момент | Основні моменти",
    "latest": "Останні",
    "live": "Наживо",
    "see_all": "Переглянути все >",
    "upcoming": "Майбутні",
    "date_added": "Дата додавання:",
    "password_new": "Новий пароль",
    "password_old": "Старий пароль",
    "password_repeat": "Повторіть пароль",
    "save": "Зберегти",
    "update": "Оновити",
    "country": "Країна",
    "phone": "Телефон",
    "search": "Пошук",
    "load_more": "Завантажити ще",
    "follow": "Підписатися",
    "following": "Підписки",
    "total": "Всього",
    "all": "Все",
    "sport_type": "Спортивний тип",
    "full_name": "Повне ім'я",
    "newest": "Найновіші",
    "oldest": "Найстаріші",
    "modal_labels": {
      "delete_clip": "Ви впевнені, що хочете видалити цей кліп?",
      "delete_highlight": "Ви впевнені, що хочете видалити це відео з основними моментами?",
      "delete_profile": "Ви впевнені, що хочете видалити свій профіль?",
      "delete_tag": "Ви впевнені, що хочете видалити ці теги? |\nВи впевнені, що хочете видалити цей тег?"
    },
    "active": "Активний",
    "submit": "Надіслати",
    "purchase": "Купити",
    "confirm_new_password": "Підтвердіть новий пароль",
    "enter_new_password": "Введіть новий пароль",
    "dark": "Темна",
    "light": "Світла",
    "powered_by": "На основі",
    "policy": "Політику конфіденційності",
    "terms": "Умови обслуговування",
    "next": "Далі",
    "search_input_placeholder": "Шукайте школи, клуби, ліги тощо.",
    "skip": "Пропустити",
    "amount": "Сума",
    "date": "Дата",
    "type": "Тип",
    "continue_with": "Продовжити з {provider}",
    "or": "або",
    "anytime": "Будь-коли",
    "event_date": "Дата події",
    "past_30_days": "За останні 30 днів",
    "past_7_days": "За останні 7 днів",
    "past_90_days": "За останні 90 днів",
    "today": "Сьогодні",
    "yesterday": "Вчора",
    "all_results": "Усі результати",
    "events": "Події",
    "views": "немає переглядів | {count} перегляд |\n{count} переглядів",
    "clip": "Кліп |\nКліпи",
    "tag": "Тег |\nТеги",
    "game_videos": "Ігрові відео",
    "bookmark_add": "Додати до вибраного",
    "bookmark_remove": "Видалити з вибраного",
    "share": "Поділитись",
    "days": "Днів | \nдень | \nднів",
    "hours": "Годин | \nгодина | \nгодин",
    "minutes": "Хвилин | \nхвилина | \nхвилин",
    "seconds": "Секунд | \nсекунда | \nсекунд",
    "latest_events": "Останні події",
    "latest_highlights": "Останні моменти",
    "statistics": "Статистика",
    "commerce_category_labels": {
      "free": "Безкоштовно",
      "member": "Учасник",
      "ppv": "Плата за перегляд",
      "subscription": "Підписка",
      "rental": "Оренда",
      "premium": "Преміум"
    },
    "lock_event_message": {
      "member": "Будь ласка, увійдіть, щоб переглянути гру",
      "geo_blocking": "Вибачте, але доступ до відео, яке ви намагаєтеся відтворити, обмежено у вашому регіоні",
      "event_restricted": "Ця подія обмежена для вашого місцезнаходження",
      "premium": "Підпишіться задля перегляду"
    },
    "main": "Головна",
    "game_highlights": "Основні моменти гри",
    "player_highlights": "Основні моменти гравця",
    "watch_full_game": "Переглянути повну гру",
    "your_clips_highlight": "Ваші кліпи/найкращі моменти",
    "create_highlight": "Створити яскравий момент",
    "access_code": "Введіть код доступу",
    "ppv_price": "Дивитися від {price}",
    "access_time": "Ви отримаєте доступ до",
    "full_access": "Повний доступ",
    "limited_access": "Обмежений доступ",
    "ppv_tickets": "Квитки PPV",
    "subscriptions": "Підписки",
    "release_date": "Дата випуску",
    "months": "Місяців | \nмісяць | \nмісяців",
    "weeks": "Тижнів | \nтиждень | \nтижнів",
    "years": "Років | \nрік | \nроків",
    "change_product": "Змінити підписку",
    "go_to_event": "Перейти на подію",
    "go_to_account": "Перейти до облікового запису",
    "go_to_main_page": "Перейти на головну сторінку",
    "name": "Ім'я",
    "update_card": "Оновити картку",
    "page_not_found": "Сторінку не знайдено",
    "inactive": "Неактивний",
    "my_club": "Мій клуб",
    "select_your_club": "Виберіть свій клуб",
    "add_to_selected": "Додати до вибраного",
    "remove_from_selected": "Видалити з вибраного",
    "password_not_match": "Паролі не збігаються",
    "search_by_sport_type": "Пошук за видом спорту",
    "videos": "Відео",
    "category": "Категорія",
    "reset_password": "Будь ласка, введіть свій новий пароль",
    "min_8_characters": "Мінімум 8 символів",
    "league": "Ліга",
    "here": "тут",
    "suggested": "Запропоновано",
    "enter_old_password": "Введіть старий пароль",
    "less": "Менше",
    "more": "Більше",
    "durationRenew": "Тривалість: буде поновлено на {duration} {units} після покупки | \nТривалість: буде поновлено {duration}",
    "duration": "Тривалість: закінчується {duration} {units} після покупки | \nТривалість: закінчується {duration}",
    "team": "Команда",
    "team_1_logo": "Логотип команди 1",
    "team_2_logo": "Логотип команди 2",
    "stats": "Статистика",
    "gameType_labels": {
      "game": "Гра",
      "other": "Інший",
      "practice": "Практика",
      "training": "навчання"
    },
    "fullName": "Повне ім'я",
    "archive": "Архів",
    "panoramic_mode": "Ви в панорамному режимі",
    "postal_code": "Поштовий індекс",
    "search_event_league_team": "Знайдіть подію, лігу чи команду",
    "back_to_site": "Повернутися на сайт",
    "done": "Готово",
    "search_teams": "Пошукові групи"
  },
  "pages": {
    "auth_sign_up": {
      "enter_your_details_below": "Введіть свої дані нижче",
      "password_updated_successuly_text": "Ваш пароль успішно оновлено",
      "already_have_account": "Вже є аккаунт?",
      "follow_category_header": "Виберіть категорії, за якими ви хочете стежити",
      "back_to_all_teams": "Назад до всіх команд",
      "follow_teams_header": "Виберіть команди, за якими ви хочете стежити",
      "back_to_all_categories": "Назад до всіх категорій"
    },
    "account": {
      "account_delete_button": "Видалити аккаунт",
      "tab_billing_title": "Платіжна інформація",
      "tab_devices_title": "Пристрої",
      "tab_general_title": "Загальні",
      "tab_password_title": "Пароль",
      "tab_subscription_title": "Підписки",
      "account_delete_confirm": "Ви впевнені, що хочете видалити свій профіль?",
      "account_delete_description": "Цю дію неможливо скасувати.",
      "tab_ppv_access_text": "Квиток PPV дає доступ до",
      "tab_ppv_no_ppv": "У вас немає квитків PPV. \nЩоб купити квиток, перейдіть на сторінку події.",
      "tab_ppv_title": "Квитки PPV",
      "account_delete_successfully": "Ваш обліковий запис успішно видалено!",
      "account_update_successfully": "Ваш обліковий запис успішно оновлено!"
    },
    "auth_passwod": {},
    "auth_password": {
      "forgot_password_help_text": "Ми допоможемо вам скинути пароль та повернути можливість увійти.",
      "back_to_sign_in": "Поверніться, щоб увійти",
      "send_reset_link": "Надіслати посилання для скидання",
      "set_new_password": "Встановити новий пароль",
      "forgot_password_success_text": "Електронний лист із інструкціями щодо скидання пароля надіслано на адресу {email}. \nЯкщо ви не отримаєте електронний лист протягом кількох хвилин, натисніть кнопку Повторно надіслати інструкції нижче.",
      "resend_instruction": "Повторно надішліть інструкції"
    },
    "clubs": {
      "manage_following": "Керувати підписками",
      "choose_your_club": "Виберіть свій клуб",
      "choose_your_club_message": "Виберіть клуб, з яким ви будете пов'язані"
    },
    "auth_login": {
      "device_no_longer_allowed_error": "Вашого поточного пристрою більше немає в списку дозволених.\nУвійдіть ще раз."
    },
    "auth_login_limit": {
      "device_limit_reached": "Досягнуто ліміту пристроїв",
      "remove_device_to_login": "Будь ласка, видаліть один, щоб увійти",
      "current_device": "Поточний пристрій"
    },
    "account_billing": {
      "card_cvv": "CVC / CVV",
      "card_expiry_date": "Термін придатності",
      "card_holder_name": "Ім'я на картці",
      "card_number": "Номер картки",
      "button_back_to_billing_info": "Повернутися до платіжної інформації",
      "payment_history_empty_text": "Ваша історія платежів порожня",
      "payment_history_title": "Історія платежів",
      "alert_credit_card_save_success": "Дані вашої кредитної картки успішно збережено",
      "alert_credit_card_update_success": "Дані вашої кредитної картки успішно оновлено",
      "label_modal_confirm_credit_card_delete": "Після видалення кредитної картки вашу підписку також буде скасовано. \nВміст доступний для вас до дати завершення плану. \nВи впевнені, що бажаєте видалити кредитну картку?",
      "alert_credit_card_delete_success": "Вашу платіжну картку успішно видалено",
      "payment_in_progress": "Виконується оплата",
      "payment_in_progress_message": "Будь ласка, не закривайте цю сторінку, доки ваш платіж не буде оброблено."
    },
    "account_subscription": {
      "active_subscription": "Активна підписка",
      "button_subscribe_now": "Підписатись зараз",
      "button_subscription_cancel": "Скасувати підписку",
      "subscription_due_date": "Термін дії",
      "subscription_expiration_date": "Термін дії закінчиться",
      "subscription_last_payment_date": "Дата останнього платежу",
      "subscription_next_charge_date": "Наступна оплата",
      "button_back_to_my_subscription": "Повернутися до моєї підписки",
      "or_select_plan": "або виберіть свій план",
      "redeem_access_code_label": "Активуйте свій код доступу тут",
      "alert_access_code_redeem_not_found": "Потрібний код доступу не існує",
      "alert_access_code_redeemed_success": "Код доступу успішно використано",
      "alert_subscription_cancel_success": "Підписку успішно скасовано",
      "label_plan_amount": "Сума плану",
      "label_taxes": "Податки",
      "label_total_billed": "Всього до сплати",
      "tab_all_subscriptions": "Усі підписки",
      "tab_my_subscriptions": "Мої підписки",
      "alert_access_code_redeem_code_used": "Запитаний код доступу вже використано",
      "label_full_access": "Повний доступ",
      "label_full_access_description": "Повний доступ до всього вмісту веб-сайту",
      "label_limited_access": "Обмежений доступ",
      "label_limited_access_description": "Обмежений доступ до всього вмісту веб-сайту",
      "subscription_expires": "Термін дії підписки закінчується {date}",
      "payment_details": "{title}: Деталі платежу",
      "no_subscriptions_text": "У списку немає активних підписок.",
      "redeem_access_code_title": "Активуйте свій код доступу",
      "button_back_to_my_tickets": "Повертаюся до моїх квитків",
      "list_subscriptions_empty": "Список доступних підписок порожній. \nПриходьте пізніше",
      "button_subscription_keep": "Зберігайте підписку",
      "cancel_subscription_modal_subtitle": "Вашу підписку буде скасовано в кінці розрахункового періоду {date}. \nВи можете змінити свою думку в будь-який час до цієї дати.",
      "cancel_subscription_modal_title": "Ви впевнені, що бажаєте скасувати підписку?",
      "checkbox_apply_as_new_credit_card": "Зберегти дані картки",
      "renew_subscription_expires": "Підписка повторюється. \nДата наступного стягнення плати {date}"
    },
    "videos": {
      "last_viewed": "Останній перегляд",
      "user_interesting": "Вам може бути цікаво",
      "description_no_items": "Це місце для ваших улюблених відео.\nЗберігайте, переглядайте та діліться!",
      "title_no_items": "Додайте кілька відео до вибраних"
    },
    "clips": {
      "title_no_clips": "У вас ще немає кліпів.\nПерейдіть до відео та створіть свій перший кліп!",
      "title_no_highlights": "У вас ще немає яскравих моментів.\nПерейдіть до відео та створіть свої перші яскраві моменти!",
      "title_no_items_with_selected_filter": "За цим фільтром не знайдено елементів"
    },
    "auth_sign_in": {
      "welcome_message": "З поверненням",
      "new_to": "Новий для",
      "auth_terms": "Продовжуючи, ви приймаєте наші {terms_of_service} і {privacy_policy}",
      "sign_in_with_provider": "Увійдіть, використовуючи свої облікові дані {provider}"
    },
    "account_password": {
      "alert_password_update_success": "Ваш пароль успішно змінено"
    },
    "league": {
      "all_rounds": "Усі раунди"
    },
    "events": {
      "event_start_date": "Подія розпочнеться {date}",
      "failed_statistics": "Не вдалося завантажити статистику, пов’язану з цією подією. Повторіть спробу пізніше.",
      "game_video_login_message": "Будь ласка, увійдіть, щоб переглянути відео гри",
      "tags_login_message": "Будь ласка, увійдіть, щоб переглянути теги",
      "modal_share_with_time": "Початок з {time}",
      "modal_share_title": "Поділіться цим відео",
      "tabs": {
        "event_tags": {
          "create_tag": "Створити тег",
          "title_no_tags_not_logged_in": "У списку ще немає тегів, увійдіть, щоб створити нові теги",
          "choose_player_color": "Введіть гравця '",
          "choose_tag": "Виберіть тип тегу",
          "make_tag_global": "Зробити тег глобальним",
          "name_the_tag": "Назвіть тег",
          "tag_creating_successfully_text": "Тег успішно створено",
          "title_enabled_tagging": "У списку немає тегів",
          "update_tag": "Оновити тег",
          "tag_updating_successfully_text": "Тег успішно оновлено",
          "filters": {
            "by_player_number": "гравець",
            "by_type": "За типом",
            "clear_all_btn": "Очистити все |\nОчистити все ({count}) |\nОчистити все ({count})",
            "no_tags": "Немає тегів, що відповідають вибраному фільтру",
            "popup_title": "Фільтр",
            "search_input_placeholder": "Шукайте певні теги",
            "show_results_btn": "Показати результати",
            "select_all": "Вибрати все | \nВибрати все ({count}) | \nВибрати все ({count})",
            "by_team": "За командою"
          },
          "tag_deleting_successfully_text": "Тег успішно видалено",
          "is_external_content": "Це зовнішній вміст, ви не можете створити тег",
          "title_no_tags": "Теги ще не створено",
          "pause_all_btn": "Призупинити все",
          "play_all_btn": "Грайте всі",
          "choose_team": "Виберіть команду"
        },
        "event_videos": {
          "create_clip": "Створити кліп",
          "title_no_clips_not_logged_in": "У списку ще немає кліпів, увійдіть, щоб створити нові",
          "name_the_clip": "Назвіть кліп",
          "clip_creating_successfully_text": "Ваш кліп скоро буде готовий",
          "title_enabled_clipping": "У списку немає кліпів",
          "title_no_clips": "Кліпів ще не створено",
          "clip_deleted_successfully_text": "Кліп успішно видалено",
          "rename_clip": "Перейменувати кліп",
          "clip_updating_successfully_text": "Кліп успішно оновлено"
        },
        "event_stats": {
          "empty_stats_data": "Дані статистики порожні",
          "game_board_title": "Статистика гри",
          "score_board_title": "Оцінка"
        }
      },
      "viewing_conditions": "Виберіть свої умови перегляду",
      "appreciation": "Дякуємо!",
      "success_purchased": "Ви успішно придбали {subscription}",
      "failed_purchased_message": "Повторіть спробу або введіть іншу картку.",
      "purchased_declined": "Платіж відхилено",
      "watching_event_by_text": "Ви спостерігаєте за цією подією через",
      "failed_code_applied_message": "Спробуйте ще раз або введіть інший код.",
      "failed_code_applied_title": "Невірний код",
      "success_code_applied": "Код {title} успішно застосовано",
      "submit_reedem_code_input_placeholder": "Введіть тут свій код доступу",
      "failed_already_used_code": "Цей код уже використовувався",
      "event_will_start_in_a_few_min": "Подія почнеться автоматично через кілька хвилин...",
      "player_errors": {},
      "success_purchased_secondary": "Ваша покупка була успішною",
      "time_till_kick_off": "Час до початку:",
      "failed_purchased_message_2": "Повторіть спробу або скористайтеся іншим способом оплати."
    },
    "club": {
      "favorite_club_creating_successfully_text": "Ваш клуб вдало обрано"
    },
    "categories": {
      "no_following_category_for_logged_user": "Зараз ви нічого не стежите. \nНатисніть {here}, щоб бути в курсі ваших улюблених подій",
      "no_following_category_for_unlogged_user": "{login}, щоб бути в курсі улюблених подій"
    }
  },
  "sport_types": {
    "americanFootball": "Американський футбол",
    "beachvolleyball": "Пляжний волейбол",
    "fieldhockey": "Хокей на траві",
    "icehockey": "Хокей",
    "rollerhockey": "Хокей на роликах",
    "badminton": "Бадмінтон",
    "baseball": "Бейсбол",
    "basketball": "Баскетбол",
    "bowling": "Боулінг",
    "cricket": "Крикет",
    "floorball": "Флорбол",
    "futsal": "Футзал",
    "gymnastics": "Гімнастика",
    "handball": "Гандбол",
    "lacrosse": "Лакросс",
    "netball": "Нетбол",
    "other": "Інший",
    "rugby": "Регбі",
    "snooker": "Снукер",
    "soccer": "Футбол",
    "softball": "Софтбол",
    "swimming": "Плавання",
    "tennis": "Теніс",
    "volleyball": "Волейбол",
    "waterpolo": "Водне поло",
    "wrestling": "Боротьба",
    "football": "Футбол"
  },
  "baseFooter": {
    "rights": "Всі права захищені"
  },
  "footer_links": {
    "about_us": "Про нас",
    "faq": "FAQ",
    "privacy_policy": "Конфіденційність",
    "terms_of_service": "Умови обслуговування",
    "custom": "{custom}"
  },
  "countries": {
    "AD": "Андорра",
    "AE": "Об'єднані Арабські Емірати",
    "AF": "Афганістан",
    "AG": "Антигуа і Барбуда",
    "AI": "Ангілья",
    "AL": "Албанія",
    "AM": "Вірменія",
    "AO": "Ангола",
    "AR": "Аргентина",
    "AS": "Американське Самоа",
    "AT": "Австрія",
    "AU": "Австралія",
    "AW": "Аруба",
    "AZ": "Азербайджан",
    "BA": "Боснія і Герцеговина",
    "BB": "Барбадос",
    "BD": "Бангладеш",
    "BE": "Бельгія",
    "BF": "Буркіна Фасо",
    "BG": "Болгарія",
    "BH": "Бахрейн",
    "BI": "Бурунді",
    "BJ": "Бенін",
    "BM": "Бермудські острови",
    "BO": "Болівія",
    "BR": "Бразилія",
    "BS": "Багамські острови",
    "BT": "Бутан",
    "BW": "Ботсвана",
    "BY": "Білорусь",
    "BZ": "Беліз",
    "CA": "Канада",
    "CF": "Центральноафриканська Республіка",
    "CG": "Конго",
    "CH": "Швейцарія",
    "CK": "Острови Кука",
    "CL": "Чилі",
    "CM": "Камерун",
    "CN": "Китай",
    "CO": "Колумбія",
    "CR": "Коста-Ріка",
    "CU": "Куба",
    "CX": "Острів Різдва",
    "CY": "Кіпр",
    "DE": "Німеччина",
    "DJ": "Джібуті",
    "DK": "Данія",
    "DM": "Домініка",
    "DO": "Домініканська республіка",
    "DZ": "Алжир",
    "EC": "Еквадор",
    "EE": "Естонія",
    "EG": "Єгипет",
    "ER": "Еритрея",
    "ES": "Іспанія",
    "ET": "Ефіопія",
    "FI": "Фінляндія",
    "FJ": "Фіджі",
    "FK": "Фолклендські острови",
    "FM": "Мікронезія",
    "FO": "Фарерські острови",
    "FR": "Франція",
    "GA": "Габон",
    "GD": "Гренада",
    "GE": "Грузія",
    "GF": "Французька Гвіана",
    "GH": "Гана",
    "GI": "Гібралтар",
    "GL": "Гренландія",
    "GM": "Гамбія",
    "GN": "Гвінея",
    "GP": "Гваделупа",
    "GQ": "Екваторіальна Гвінея",
    "GR": "Греція",
    "GS": "Південна Джорджія та Південні Сандвічеві острови",
    "GT": "Гватемала",
    "GU": "Гуам",
    "GW": "Гвінея-Бісау",
    "GY": "Гайана",
    "HN": "Гондурас",
    "HR": "Хорватія",
    "HT": "Гаїті",
    "HU": "Угорщина",
    "ID": "Індонезія",
    "IE": "Ірландія",
    "IL": "Ізраїль",
    "IN": "Індія",
    "IO": "Британська територія в Індійському океані",
    "IQ": "Ірак",
    "IR": "Іран",
    "IS": "Ісландія",
    "IT": "Італія",
    "JM": "Ямайка",
    "JO": "Йорданія",
    "JP": "Японія",
    "KE": "Кенія",
    "KG": "Киргизстан",
    "KH": "Камбоджа",
    "KI": "Кірібаті",
    "KM": "Коморські острови",
    "KW": "Кувейт",
    "KY": "Кайманові острови",
    "KZ": "Казахстан",
    "LB": "Ліван",
    "LI": "Ліхтенштейн",
    "LK": "Шрі Ланка",
    "LR": "Ліберія",
    "LS": "Лесото",
    "LT": "Литва",
    "LU": "Люксембург",
    "LV": "Латвія",
    "LY": "Лівія",
    "MA": "Марокко",
    "MC": "Монако",
    "MD": "Молдова",
    "ME": "Чорногорія",
    "MG": "Мадагаскар",
    "MH": "Маршаллові острови",
    "ML": "Малі",
    "MM": "М'янма",
    "MN": "Монголія",
    "MP": "Північні Маріанські острови",
    "MQ": "Мартініка",
    "MR": "Мавританія",
    "MS": "Монсеррат",
    "MT": "Мальта",
    "MU": "Маврикій",
    "MV": "Мальдіви",
    "MW": "Малаві",
    "MX": "Мексика",
    "MY": "Малайзія",
    "NA": "Намібія",
    "NC": "Нова Каледонія",
    "NE": "Нігер",
    "NF": "Острів Норфолк",
    "NG": "Нігерія",
    "NI": "Нікарагуа",
    "NL": "Нідерланди",
    "NO": "Норвегія",
    "NP": "Непал",
    "NR": "Науру",
    "NU": "Ніуе",
    "NZ": "Нова Зеландія",
    "OM": "Оман",
    "PA": "Панама",
    "PE": "Перу",
    "PF": "Французька Полінезія",
    "PG": "Папуа-Нова Гвінея",
    "PH": "Філіппіни",
    "PK": "Пакистан",
    "PL": "Польща",
    "PR": "Пуерто-Рико",
    "PT": "Португалія",
    "PW": "Палау",
    "PY": "Парагвай",
    "QA": "Катар",
    "RO": "Румунія",
    "RS": "Сербія",
    "RW": "Руанда",
    "SA": "Саудівська Аравія",
    "SB": "Соломонові острови",
    "SC": "Сейшельські острови",
    "SD": "Судан",
    "SE": "Швеція",
    "SG": "Сінгапур",
    "SI": "Словенія",
    "SK": "Словаччина",
    "SL": "Сьєрра-Леоне",
    "SM": "Сан-Марино",
    "SN": "Сенегал",
    "SV": "Сальвадор",
    "TC": "Острови Теркс і Кайкос",
    "TD": "Чад",
    "TG": "Тоґо",
    "TH": "Таїланд",
    "TJ": "Таджикистан",
    "TK": "Токелау",
    "TM": "Туркменістан",
    "TN": "Туніс",
    "TO": "Тонга",
    "TR": "Туреччина",
    "TT": "Тринідад і Тобаго",
    "TV": "Тувалу",
    "TW": "Тайвань",
    "UA": "Україна",
    "UG": "Уганда",
    "UY": "Уругвай",
    "UZ": "Узбекистан",
    "VE": "Венесуела",
    "VU": "Вануату",
    "WF": "Уолліс і Футуна",
    "WS": "Самоа",
    "YE": "Ємен",
    "YT": "Майотта",
    "ZA": "Південна Африка",
    "ZM": "Замбія",
    "ZW": "Зімбабве",
    "BN": "Бруней",
    "CV": "Кабо-Верде",
    "CW": "Кюрасао",
    "HK": "Гонконг, САР Китаю",
    "KP": "Північна Корея",
    "KR": "Південна Корея",
    "LA": "Лаос",
    "MO": "Макао, САР Китаю",
    "PS": "Палестинська територія",
    "RE": "Возз'єднання",
    "RU": "Росія",
    "AC": "Вознесіння",
    "SY": "Сирія",
    "TZ": "Танзанія",
    "GB": "Об'єднане Королівство",
    "US": "Сполучені Штати",
    "VG": "Британські Віргінські острови",
    "VI": "Віргінські острови США",
    "VN": "В'єтнам",
    "CD": "Конго, дем.\nРеспубліка (Заїр)",
    "AX": "Аландські острови",
    "BQ": "Карибські Нідерланди",
    "EA": "Сеута і Мелілья",
    "EH": "Західна Сахара",
    "GG": "Гернсі",
    "IC": "Канарські острови",
    "IM": "Острів Мен",
    "JE": "Джерсі",
    "MZ": "Мозамбік",
    "PN": "Острови Піткерн",
    "SO": "Сомалі",
    "SS": "Південний Судан",
    "SX": "Сінт-Мартен",
    "TA": "Трістан да Кунья",
    "TF": "Французькі Південні території",
    "VA": "Ватикан",
    "XK": "Косово",
    "CZ": "Чехія",
    "CC": "Кокосові (Кілінгові) острови",
    "TL": "Тимор-Лешті",
    "CI": "Кот д'Івуар",
    "MK": "Північна Македонія",
    "SR": "Сурінам",
    "SZ": "Есватіні",
    "DG": "Дієго Гарсія"
  },
  "errors": {
    "expired_session_error": "Ваш сеанс закінчився. \nБудь ласка, увійдіть знову.",
    "vod_files_not_found": "Ой! \nВідеофайли не знайдені",
    "vod_playback_failed": "Ой! \nПомилка відтворення під час трансляції VOD",
    "could_not_find_event": "На жаль, нам не вдалося знайти подію, яку ви шукаєте.",
    "could_not_find_page": "На жаль, нам не вдалося знайти сторінку, яку ви шукаєте.",
    "could_not_find_team": "На жаль, нам не вдалося знайти команду, яку ви шукаєте.",
    "event_not_found": "Подія не знайдена",
    "page_not_found": "Сторінку не знайдено",
    "team_not_found": "Команда не знайдена",
    "could_not_find_results": "Вибачте, ми не знайшли результатів для цього пошуку.",
    "ERR400CL11": "Не вдалося створити кліп",
    "ERR400CM11": "Платіж не вдалося",
    "ERR400CM12": "Не вдалося розмістити замовлення",
    "ERR400CM13": "Помилка платежу за захоплення",
    "ERR400CM14": "Підписка не зберегла інформацію про продавця",
    "ERR400CM15": "Будь ласка, перевірте дані своєї кредитної картки",
    "ERR400CM16": "Вказано недійсне значення платформи",
    "ERR400GN00": "Поганий запит",
    "ERR400GN11": "Надано недійсний ідентифікатор",
    "ERR400GN12": "Не надано оновлювані поля",
    "ERR400ID11": "Надано недійсну особу",
    "ERR400ID12": "Надано недійсний елемент ідентифікації",
    "ERR400ID13": "Ідентичність не можна додати до списку клубів",
    "ERR400ID14": "Надано недійсну пару посвідчення та елемента посвідчення",
    "ERR400TG11": "Не вдалося створити тег",
    "ERR400UR11": "Ім'я та прізвище профілю обов'язкові",
    "ERR400UR12": "Необхідно вказати адресу електронної пошти",
    "ERR400UR13": "У користувача вже є збережена кредитна картка",
    "ERR400UR14": "Перш ніж зберегти кредитну картку, заповніть поля імені, прізвища та електронної пошти свого профілю",
    "ERR400UR17": "Користувач не має кредитної картки для редагування",
    "ERR400UR18": "Підписку вже скасовано",
    "ERR400UR19": "Підписка не активна",
    "ERR400UR20": "Ім'я користувача та пароль обов'язкові",
    "ERR400UR21": "Обліковий запис не активний",
    "ERR401AT11": "Потрібен маркер",
    "ERR401AT12": "Недійсний маркер скидання пароля",
    "ERR401AT13": "Недійсний маркер оновлення",
    "ERR401AT14": "Невідомий суб'єкт емітент",
    "ERR401AT15": "Непідтримуваний тип маркера теми",
    "ERR401AT16": "Неприпустимий маркер",
    "ERR401AT17": "Термін дії маркера закінчився",
    "ERR401AT18": "Не вдалося отримати електронний лист від маркера",
    "ERR401AT19": "Користувач не знайдений",
    "ERR401GN00": "Несанкціонований",
    "ERR401UR11": "Ім'я користувача або пароль неправильні. \nПеревірте свої облікові дані.",
    "ERR402GN00": "Потрібна оплата",
    "ERR403GN00": "Заборонено",
    "ERR403TG11": "Користувач не може оновити глобальні теги",
    "ERR403TG12": "Користувач не може створювати глобальні теги",
    "ERR403TG13": "Користувач не може видалити теги, створені не ним",
    "ERR403TG14": "Користувач не може видалити глобальні теги",
    "ERR404CM11": "Неможливо отримати підписку",
    "ERR404CM12": "Код доступу не знайдено",
    "ERR404EV11": "Не вдається отримати інформацію про подію",
    "ERR404EV12": "Подію або VOD не знайдено",
    "ERR404GN00": "Не знайдено",
    "ERR404ID00": "Особа не знайдена",
    "ERR404ID11": "Ідентичність не вдалося відновити",
    "ERR404PR00": "Продукт не знайдено",
    "ERR404PR11": "Не вдається отримати інформацію про ppv",
    "ERR404TG00": "Тег не знайдено",
    "ERR404TM00": "Команда не знайдена",
    "ERR404UR00": "Користувач не знайдений",
    "ERR404UR11": "Замовлення не знайдено",
    "ERR404UR12": "Підписка не знайдена",
    "ERR404UR13": "Користувач не існує",
    "ERR404UR14": "Профіль не існує",
    "ERR404UR15": "Для цього користувача картку не знайдено",
    "ERR404UR16": "Відео не знайдено в списку перегляду",
    "ERR404VD11": "Воду не вдалося отримати",
    "ERR409CM11": "Код доступу вже використовується",
    "ERR409GN00": "Конфлікт",
    "ERR409PR12": "Товар вже придбано",
    "ERR409UR11": "Клуб вже доданий",
    "ERR409UR12": "Користувач уже зареєстрований",
    "ERR422GN00": "Вміст, що не підлягає обробці",
    "ERR451GN00": "Недоступний з юридичних причин",
    "ERR500GN00": "Внутрішня помилка сервера",
    "ERR500NT12": "Не вдалося надіслати електронний лист для скидання пароля",
    "ERR501GN00": "Не впроваджений",
    "ERR502GN00": "Невірний шлюз",
    "ERR503GN00": "Послуга недоступна",
    "ERR504GN00": "Час очікування шлюзу",
    "could_not_find_league": "На жаль, нам не вдалося знайти лігу, яку ви шукаєте.",
    "default_error_message": "Сталася помилка сервера. \nБудь-ласка спробуйте пізніше",
    "device_limit_exceeded": "Ліміт пристрою перевищено!",
    "league_not_found": "Ліга не знайдена",
    "vod_corrupted_files": "Не вдалося завантажити відео",
    "passwords_dont_match": "Паролі не збігаються",
    "incomplete_cvc": "Код безпеки вашої картки неповний!",
    "incomplete_expiry": "Термін дії вашої картки неповний!",
    "incomplete_number": "Номер вашої картки неповний!",
    "invalid_expiry_month_past": "Рік закінчення терміну дії вашої картки минув!",
    "invalid_expiry_year": "Рік закінчення терміну дії картки недійсний!",
    "invalid_expiry_year_past": "Рік закінчення терміну дії вашої картки минув!",
    "invalid_number": "Номер вашої картки недійсний!",
    "popup_closed": "Спливаюче вікно закрито",
    "login_failed": "Помилка логіну",
    "ERR400UR24": "Старий пароль неправильний. \nПеревірте свої облікові дані"
  },
  "tags": {
    "baseball_bottom_1st": "нижній 1-й",
    "baseball_bottom_2nd": "нижній 2-й",
    "baseball_double": "подвійний",
    "baseball_double_play": "подвійна гра",
    "baseball_fly_out": "Вилетіти",
    "baseball_ground_out": "витерти",
    "baseball_hit": "удар",
    "baseball_home_run": "домашній біг",
    "baseball_popout": "вискочити",
    "baseball_run": "бігати",
    "baseball_single": "одиночний",
    "baseball_stolen_base": "вкрадена база",
    "baseball_strikeout": "викреслити",
    "baseball_substitution": "заміна",
    "baseball_top_1st": "верхня 1ст",
    "baseball_top_2nd": "верхня 2-я",
    "baseball_triple_play": "потрійна гра",
    "baseball_tripple": "потрійний",
    "baseball_walk": "ходити",
    "basketball_alley_oop": "алея ооп",
    "basketball_assist": "допомогти",
    "basketball_big_play": "велика гра",
    "basketball_block": "блокувати",
    "basketball_dunk": "данк",
    "basketball_momentym": "імпульс",
    "basketball_money_time": "гроші час",
    "basketball_substitution": "заміна",
    "basketball_three_point": "три точки",
    "beach_volleyball_dig": "копати",
    "beach_volleyball_double": "подвійний",
    "beach_volleyball_free_ball": "вільний м'яч",
    "beach_volleyball_match_point": "матч-пойнт",
    "beach_volleyball_mishit": "помилка",
    "beach_volleyball_serve": "служити",
    "beach_volleyball_set_point": "задане значення",
    "beach_volleyball_shank": "хвостовик",
    "beach_volleyball_side_out": "стороною назовні",
    "beach_volleyball_spike": "шип",
    "beach_volleyball_substitution": "заміна",
    "field_ball_loss": "втрата м'яча",
    "field_ball_possesion": "володіння м'ячем",
    "field_circle_penetration": "коло проникнення",
    "field_hockey_4v4": "4 на 4",
    "field_hockey_big_hit": "великий удар",
    "field_hockey_fight": "боротися",
    "field_hockey_goal": "гол",
    "field_hockey_other": "інший",
    "field_hockey_power_play": "силова гра",
    "field_hockey_save": "зберегти",
    "field_hockey_shot": "постріл",
    "field_hockey_substitution": "заміна",
    "field_interception": "перехоплення",
    "field_penalty_corner": "штрафний кут",
    "field_press_fp_hc": "преса",
    "field_time_penalty": "часовий штраф",
    "field_turn_over": "перевертати",
    "football_big_catch": "великий улов",
    "football_big_hit": "великий удар",
    "football_big_run": "великий біг",
    "football_field_goal": "польовий гол",
    "football_kick_return": "віддача ногою",
    "football_kickoff": "стартовий удар",
    "football_punt_return": "punt повернення",
    "football_substitution": "заміна",
    "football_touch_down": "торкнутися вниз",
    "futsal_corner_kick": "кутовий удар",
    "futsal_foul": "фол",
    "futsal_free_kick": "штрафний удар",
    "futsal_goal": "гол",
    "futsal_header": "заголовок",
    "futsal_penalty": "пенальті",
    "futsal_redcard": "червона картка",
    "futsal_save": "зберегти",
    "futsal_shot": "постріл",
    "futsal_shot_on_target": "постріл в ціль",
    "futsal_substitution": "заміна",
    "futsal_yellowcard": "жовта картка",
    "general_bad": "погано",
    "general_drill": "дриль",
    "general_good": "добре",
    "gymnastic_wow": "Ого",
    "handball_foul": "фол",
    "handball_goal": "гол",
    "handball_penalty_shot": "пенальті",
    "handball_red_card": "червона картка",
    "handball_save": "зберегти",
    "handball_shot_on_goal": "удар по воротах",
    "handball_substitution": "заміна",
    "handball_suspension": "підвіска",
    "handball_yellow_card": "жовта картка",
    "hockey_4v4": "4 на 4",
    "hockey_big_hit": "великий удар",
    "hockey_fight": "боротися",
    "hockey_goal": "гол",
    "hockey_power_play": "силова гра",
    "hockey_save": "зберегти",
    "hockey_shot": "постріл",
    "hockey_substitution": "заміна",
    "lacrosse_clear": "ясно",
    "lacrosse_face_off": "зіткнутися, зіштовхнутися, зустрітися із",
    "lacrosse_goal": "гол",
    "lacrosse_ground_ball": "наземний м'яч",
    "lacrosse_man_up": "доукомплектувати",
    "lacrosse_penalty": "пенальті",
    "lacrosse_save": "зберегти",
    "lacrosse_shot": "постріл",
    "lacrosse_substitution": "заміна",
    "other_wow": "ого",
    "roller_ball_loss": "втрата м'яча",
    "roller_ball_possesion": "володіння м'ячем",
    "roller_circle_penetration": "коло проникнення",
    "roller_hockey_4v4": "4 на 4",
    "roller_hockey_big_hit": "великий удар",
    "roller_hockey_fight": "боротися",
    "roller_hockey_goal": "гол",
    "roller_hockey_other": "інший",
    "roller_hockey_power_play": "силова гра",
    "roller_hockey_save": "зберегти",
    "roller_hockey_shot": "постріл",
    "roller_hockey_substitution": "заміна",
    "roller_interception": "перехоплення",
    "roller_penalty_corner": "куточок",
    "roller_press_fp_hc": "преса",
    "roller_time_penalty": "часовий штраф",
    "roller_turn_over": "перевертати",
    "rugby_break_down": "зламатися",
    "rugby_conversion": "перетворення",
    "rugby_drop_goal": "падіння гол",
    "rugby_garry_owen": "Гаррі Оуен",
    "rugby_grubber": "корчувач",
    "rugby_knock_on": "стукати",
    "rugby_maul": "молотка",
    "rugby_penalty_try": "спроба пенальті",
    "rugby_substitution": "заміна",
    "soccer_corner_kick": "кутовий удар",
    "soccer_foul": "фол",
    "soccer_free_kick": "штрафний удар",
    "soccer_goal": "гол",
    "soccer_header": "заголовок",
    "soccer_penalty": "пенальті",
    "soccer_redcard": "червона картка",
    "soccer_save": "зберегти",
    "soccer_shot": "постріл",
    "soccer_shot_on_target": "постріл в ціль",
    "soccer_substitution": "заміна",
    "soccer_yellowcard": "жовта картка",
    "volleyball_dig": "копати",
    "volleyball_double": "подвійний",
    "volleyball_free_ball": "вільний м'яч",
    "volleyball_match_point": "матч-пойнт",
    "volleyball_mishit": "помилка",
    "volleyball_serve": "служити",
    "volleyball_set_point": "задане значення",
    "volleyball_shank": "хвостовик",
    "volleyball_side_out": "стороною назовні",
    "volleyball_spike": "шип",
    "volleyball_substitution": "заміна",
    "wrestling_wow": "Ого"
  }
}
